__webpack_require__.p = "https://www.eurekaforbes.com/cms/assets/web/3995d11/_next/";